<template>
  <div class="row theme-dropdown">
    <div class="btn-group col-xs-3">
      <button
        type="button"
        class="btn btn-default dropdown-toggle"
        :class="selectedThemeKey ? 'button-size' : ''"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <span class="pull-left" :id="selectionId"
          ><template v-if="!selectedThemeKey">Random Color</template>
          <template v-else
            ><div
              class="theme-color-selected mr-5"
              :style="`background-color: ${
                themes[selectedThemeKey - 1] ? themes[selectedThemeKey - 1].backgroundColor : null
              }`"
            ></div></template
        ></span>
        <span class="caret"></span>
      </button>

      <ul class="dropdown-menu">
        <button class="btn btn-default mb-5" @click.prevent="$emit('select', null)">
          Random Color
        </button>

        <template v-for="(column, idx) in columns">
          <div :key="`color-${idx + 1}`" class="flex">
            <template v-for="({ backgroundColor }, idx2) in column">
              <theme-color
                :key="`colll-${idx}-${idx2}`"
                :background-color="backgroundColor"
                @click="handleClick"
                :idx="idx * 4 + idx2 + 1"
              />
            </template>
          </div>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import ThemeColor from './ThemeColor.vue';
  export default {
    model: {
      // this maps v-model value to selectedThemeKey
      prop: 'selectedThemeKey',
    },

    props: {
      selectedThemeKey: {
        type: Number,
        default: null,
      },
      selectionId: {
        type: String,
        default: '',
      },
    },

    data() {
      return {
        cols: 6,
      };
    },

    components: {
      ThemeColor,
    },

    methods: {
      handleClick(val) {
        this.$emit('select', val);
      },
    },

    computed: {
      ...mapState('editMode/characters', ['themes']),
      //separate theme array into different sets of arrays to display it in flex
      columns() {
        const columns = [];
        let mid = this.themes.length / this.cols;
        for (let i = 0; i < this.cols; i++) {
          columns.push(this.themes.slice(i * mid, i * mid + mid));
        }
        return columns;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .theme-dropdown {
    margin-left: 0;
    margin-right: 0;

    .btn-group {
      padding: 0;
      button,
      ul {
        width: 100%;
        text-align: center;
      }
      ul {
        min-width: 147px;
      }
      .caret {
        position: absolute;
        top: 50%;
        right: 15px;
        transform: translateY(-50%);
      }
      .button-size {
        width: 50%;
      }
    }
  }
</style>
